import React from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import LoadAddForm from '../../components/Forms/load-add-form';

const LoadsAddPage = () => {
  const { getThemeColors } = useTheme();
  const colors = getThemeColors();
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/loads');
  };

  const handleSuccess = (newLoad) => {
    navigate('/loads');
  };

  return (
    <Container fluid style={{ backgroundColor: colors.background, minHeight: '100vh' }}>
      <div style={{ padding: '24px' }}>
        <LoadAddForm
          onClose={handleClose}
          onSuccess={handleSuccess}
        />
      </div>
    </Container>
  );
};

export default LoadsAddPage;














